import { DragFileBrowseData } from "./media"



export class widgetTranslationModeData {
    originalLanguageData:boolean
    dragFileData:DragFileBrowseData
    dragFileDataOriginal:DragFileBrowseData

    translations: any//this.translationForm.value.translations,
    fields: any//this.widgetsTranslationsFields[widget.type],
    columns:string[]// this.widgetsWithTranslations[widget.type],//['title', 'subtitle','text'],
    values: any//widget,
    type: string//widget.type,
    valuesTranslated: any//alltranslationsWidget,
    languages: string[]//translationsWidget,
    selectedLanguage:string//this.translationForm.value.selectedLanguage,
    oldTemplateData:any//this.oldTemplateData,
    passId: string//this.idToShow,
    contentTypeId:string//this.contentTypeId,
    widget:number//index,
    defaultLanguageWidgetData: any//widgetDefaultLanguage
    defaultLanguage: string//widgetDefaultLanguage
    widgetId:string
}

export class IWidgetReturnTranslatedValues {
    url?:string //billboardImage //billboardVideo
    linkURL?:string //billboardImage
    imageUrl?:string // callToAction
    title?:string // video 
    subtitle?:string // video
    expiredMessage?:string // countdown
    images?:any //images
    unregisteredText?:string // productRegistration
    registeredText?:string // productRegistration
    content?:any // composed
    sections?:any // form
    submitTitle?:string // form
    submitAgainTitle?:string // form
    successMessage?:string // form
    altTitle?:string
}

export function checkIfFieldDisabled(fieldKey, fields, originalLanguageData) {
    let field = fields.find( field => field.key === fieldKey)
    let disabled = originalLanguageData

    if(!field)
      disabled = true

    return disabled
  }

 export interface composedNode{
    content: contentNode[];
  }
  export interface contentNode {
    attributes?: attributesNode;
    type:string; //text, image, hstack, vstack, zstack, circle, rectangle, (overlay)
    children?:contentNode[];//**for : hstack, vstack, zstack */
    id:string//**********need to add support for this */
  }
  
  export interface attributesNode{
    text?:string;//*text
    url?:string;//*image
    font?:string /// *******plain, bold, italic, title, subtitle
    fontSize?:number; // in pt
    spacing?: number; // in pt/dp
    padding?:string; // {top, leading, trailing, bottom : float}
    horizontalAlignment?: string; // leading, center, trailing
    verticalAlignment?: string; // top, center, bottom
    alignment?: string; // topLeading, topCenter, topTrailing
    width?: number;
    height?:number;
    aspectRatio?: number;
    cornerRadius?: number;
    radius?:number;
    foregroundColor?:string;
    backgroundColor?:string;
    fillColor?:string;
    strokeColor?:string;
    // color?:string; // background, primary, secondary, accent, title, subtitle
  }